Vue.component('HistoryTable', require('./HistoryTable').default);
Vue.component('HistoryEventsList', require('./HistoryEventsList').default);
